<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 107.074 197.209"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="74.011"
            cy="130.373"
            r="9.984"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M64.866 182.93c4.643,4.279 9.197,5.295 16.465,5.101 -3.768,1.227 -9.018,0.89 -13.779,1.627 -2.624,0.405 -5.114,1.116 -7.602,1.812 -6.228,-7.758 -12.029,-10.063 -17.404,-6.912 -3.351,1.339 -6.751,3.648 -10.201,6.927 -1.766,-0.208 -3.739,-0.342 -6.089,-0.334 -2.093,0.007 -4.047,-0.553 -5.829,-1.488 7.36,0.291 10.042,-2.025 15.451,-8.845 1.071,-1.35 2.47,-2.408 4.094,-3.178 5.136,-2.432 12.527,-1.983 18.95,1.215 2.127,1.059 4.147,2.419 5.944,4.075z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M81.331 188.031c-7.268,0.194 -11.822,-0.822 -16.465,-5.101 -1.797,-1.656 -3.817,-3.016 -5.944,-4.075 0.417,-7.706 0.587,-13.839 0.51,-18.398 9.324,-1.263 18.513,-4.37 27.567,-9.321 2.061,5.276 2.392,12.308 2.47,16.502 0.121,6.488 0.56,14.785 -5.778,19.253 -0.69,0.486 -1.485,0.855 -2.36,1.14z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M39.523 160.378c0.282,10.829 0.432,16.584 0.449,17.262 -1.624,0.77 -3.023,1.828 -4.094,3.178 -5.409,6.82 -8.091,9.136 -15.451,8.845 -5.668,-2.972 -9.584,-9.725 -10.611,-13.986 -0.169,-6.101 -1.851,-17.217 -0.276,-25.385 10.139,5.339 20.133,8.701 29.983,10.086z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M39.523 160.378c-9.85,-1.385 -19.844,-4.747 -29.983,-10.086 0.619,-3.211 1.74,-5.966 3.655,-7.782 14.037,-0.225 25.83,-1.576 35.341,-1.839 13.518,-0.374 27.142,-1.07 34.87,5.108 0.173,0.139 0.341,0.285 0.505,0.438 1.319,1.24 2.322,2.958 3.088,4.919 -9.054,4.951 -18.243,8.058 -27.567,9.321 -6.569,0.889 -13.206,0.863 -19.909,-0.079z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M39.972 177.64c-0.017,-0.678 -0.167,-6.433 -0.449,-17.262 6.703,0.942 13.34,0.968 19.909,0.079 0.077,4.559 -0.093,10.692 -0.51,18.398 -6.423,-3.198 -13.814,-3.647 -18.95,-1.215z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M59.95 191.47c-6.228,-7.758 -12.029,-10.063 -17.404,-6.912 -3.351,1.339 -6.751,3.648 -10.201,6.927m16.191 -50.814c13.518,-0.374 27.142,-1.07 34.87,5.108 5.333,4.265 5.952,15.912 6.063,21.859 0.121,6.488 0.56,14.785 -5.778,19.253 -3.663,2.581 -10.272,1.859 -16.139,2.767 -6.022,0.931 -11.337,3.466 -17.547,3.749 -10.326,0.472 -13.339,-2.292 -23.749,-2.256 -8.751,0.03 -15.09,-9.873 -16.44,-15.474 -0.235,-8.499 -3.407,-26.73 3.379,-33.167 14.037,-0.225 25.83,-1.576 35.341,-1.839zm36.838 -83.457c3.209,10.166 2.755,39.439 -1.478,89.18m1.478 -89.18c-4.882,-13.799 -9.362,-17.159 -13.441,-10.08 -10.401,39.497 -18.209,53.322 -23.426,41.474m0 0c-5.619,-15.929 -6.188,-29.572 -6.432,-45.027 -0.165,-10.437 -8.839,-10.599 -17.281,1.152 -6.405,7.136 -10.31,21.344 -11.714,42.624 0.485,16.126 0.517,34.847 0.095,56.161m29.249 -87.99c1.907,-6.529 4.86,-12.801 8.857,-18.818 11.83,-15.292 18.09,-9.507 18.78,17.356"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="67.769"
            cy="26.739"
            r="9.984"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
